import {Component} from '@angular/core';
import {NgOptimizedImage} from '@angular/common';

@Component({
  selector: 'app-adobe-cc-apps',
  standalone: true,
  imports: [
    NgOptimizedImage
  ],
  templateUrl: './adobe-cc-apps.component.html',
  styleUrl: './adobe-cc-apps.component.scss'
})
export class AdobeCcAppsComponent {
  apps = [
    {
      appName: 'Acrobat',
      description: 'PDF documents and forms',
      iconPath: 'acrobat-pro.svg'
    },
    {
      appName: 'Photoshop',
      description: 'Photos and images editor',
      iconPath: 'photoshop.svg'
    },
    {
      appName: 'Illustrator',
      description: 'Vector graphics editor',
      iconPath: 'illustrator.svg'
    },
    {
      appName: 'InDesign',
      description: 'Design and layout for publishing',
      iconPath: 'indesign.svg'
    },
    {
      appName: 'Premiere',
      description: 'Film and video editor',
      iconPath: 'premiere-pro.svg'
    },
    {
      appName: 'AfterEffects',
      description: 'Visual effects and motion graphics',
      iconPath: 'after-effects.svg'
    },
    {
      appName: 'XD',
      description: 'User experience design',
      iconPath: 'xd.svg'
    },
    {
      appName: 'Audition',
      description: 'Audio editor',
      iconPath: 'audition.svg'
    },
    {
      appName: 'Dreamweaver',
      description: 'Web design and development',
      iconPath: 'dreamweaver.svg'
    },
    {
      appName: 'Animate',
      description: 'Animation',
      iconPath: 'animate.svg'
    },
    {
      appName: 'Lightroom',
      description: 'Image storage and organization',
      iconPath: 'lightroom.svg'
    },
    {
      appName: 'Aero',
      description: 'Augmented reality',
      iconPath: 'aero.svg'
    }
  ];
}
